import {
  ButtonProps,
  IconButton,
  styled,
  Button as MuiButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";

const ArrowNextIcon = styled(ArrowBackIcon)`
  transform: rotate(180deg);
`;
const Button = styled(IconButton)`
  border: 1px solid ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.main};
  padding: 4px;
  background: white;
  width: 39px;
  height: 39px;
  pointer-events: all;
`;

interface NextScreenProps extends ButtonProps {
  Component?: React.ReactNode;
}
export const NextScreen = ({ Component, ...props }: NextScreenProps) => {
  if (Component)
    return (
      <MuiButton
        {...props}
        variant="contained"
        sx={{
          background: "white",
          borderColor: (theme) => theme.palette.primary.main,
          borderWidth: 1,
          borderStyle: "solid",
          borderRadius: 6,
          "&:hover": {
            background: (theme) => theme.palette.grey[200],
          },
          pointerEvents: "all",
        }}
      >
        {Component}
      </MuiButton>
    );
  return (
    <Button {...props}>
      <ArrowNextIcon />
    </Button>
  );
};

export const PrevScreen = (props: ButtonProps) => {
  return (
    <Button {...props}>
      <ArrowBackIcon />
    </Button>
  );
};

const Container = styled("div")`
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 1200px;
  margin-left: -30px;
  padding: 0 15px;
  z-index: 1;
  pointer-events: none;
`;
interface NavigationContainerProps {
  handleNext?: () => void;
  handlePrev?: () => void;
  nextComponent?: React.ReactNode;
}
export const NavigationContainer = (props: NavigationContainerProps) => {
  return (
    <Container>
      <PrevScreen onClick={props.handlePrev} />
      {props.handleNext && (
        <NextScreen
          onClick={props.handleNext}
          Component={props.nextComponent}
        />
      )}
    </Container>
  );
};
